module.exports = [{"type":"title","text":"2024-08-22"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"Perpetual WebSocket: Added 'cr' field for realized profit and loss in position data."},{"type":"html","text":"Spot Market API: Added 'offTime' and 'maintainTime' fields to the /openApi/spot/v1/common/symbols endpoint."},{"type":"html","text":"Perpetual Market API: Added 'brokerState' field to the /openApi/swap/v2/quote/contracts endpoint."}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/changelog/2024-08-22.json
// module id = POz2
// module chunks = 3